<div class="kz-backtotop"
     [ngClass]="{'show-kz-backtotop': navIsFixed}">
  <button title="Revenir en haut de la page" (click)="scrollToTop()">
    <kz-icons name="arrowup"  ></kz-icons>
  </button>
</div>
